import { supabaseClient } from "supabase";

export type CreateNotificationParams = {
  eventId: number;
  message: string;
  message_pt: string;
};

export const createNotification = async ({
  eventId,
  message,
  message_pt,
}: CreateNotificationParams) => {
  const { error } = await supabaseClient.rpc("sendpushtobookmarks", {
    event_id: eventId,
    message_en: message,
    message_pt,
  });

  if (error) {
    throw error;
  }
};
